import React from 'react';
import { IonButton } from '@ionic/react';
import { useSwiper } from 'swiper/react';
import { WelcomeSlide } from './WelcomeSlide';
import { SlideHeading } from './SlideHeading';
import { SlideActions } from './SlideActions';
import { SlideButton } from './SlideButton';
import { ISignIn } from './WelcomeTypes';

export const CONVERSATIONS_SLIDE_HEADING = 'Catch Every Word';

interface IConversationsSlideProps {
    isAnonymous: boolean;
    signIn: ISignIn;
    onTermsClick: () => void;
    onAdvance: () => Promise<void>;
}

export const ConversationsSlide: React.FC<IConversationsSlideProps> = ({ isAnonymous, signIn, onTermsClick, onAdvance }) => {
    const swiper = useSwiper();

    const handleAdvance = async () => {
        await onAdvance();
        swiper.slideNext();
    };

    return (
        <WelcomeSlide image="1-conversations.webp">
            <SlideHeading
                title={CONVERSATIONS_SLIDE_HEADING}
                description={<>Care conversations move fast.<br/><b>Innerhive</b> takes notes so<br/>you can stay present.</>}
            />
            <SlideActions>
                <div style={{textAlign: 'center', padding: '12px 0 0', fontSize: 12, color: 'var(--ion-color-step-700)'}}>
                    By continuing, you agree to our{' '}
                    <a
                        href="https://www.innerhive.com/terms-of-service"
                        target="_blank"
                        rel="noreferrer"
                        onClick={onTermsClick}
                        style={{color: 'var(--ion-color-step-700)'}}
                    >Terms</a>
                </div>
                {isAnonymous &&
                    <IonButton fill="clear" type="button" onClick={() => signIn({ trackingFrom: 'Welcome Existing Account' })}>I already have an account</IonButton>
                }
                <SlideButton onClick={handleAdvance}>Tell me more...</SlideButton>
            </SlideActions>
        </WelcomeSlide>
    );
};
